import React from 'react';
import Styles from './cash-button-styles.scss';
import { CashIcon, ClaimedIcon, LockIcon } from '../icons';
import classNames from 'classnames';
const CashButton = ({ type, text, onClick = () => {
    console.log('clicked');
} }) => {
    const setIconByType = (type) => {
        switch (type) {
            case 'locked':
                return React.createElement(LockIcon, null);
            case 'cash':
                return React.createElement(CashIcon, null);
            case 'claimed':
                return React.createElement(ClaimedIcon, null);
        }
    };
    return (React.createElement("button", { className: classNames([Styles.cashButtonCont, Styles[type]]), onClick: onClick },
        React.createElement("div", { className: Styles.icon }, setIconByType(type)),
        React.createElement("div", { className: Styles.text }, text)));
};
export default CashButton;
